import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take, switchMap, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-callback',
  template: `
    <div class="flex min-h-screen items-center justify-center bg-background">
      <div class="text-center">
        <div class="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-border border-t-primary"></div>
        <p class="mt-4 text-sm text-muted-foreground">Iniciando sesión...</p>
      </div>
    </div>
  `
})
export class CallbackComponent implements OnInit {
  private readonly auth0 = inject(AuthService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    // Listen for any authentication errors during callback handling
    this.auth0.error$.pipe(
      filter(err => !!err),
      take(1)
    ).subscribe(err => {
      console.error('Auth error in callback:', err);
      // Logout the user to clear any stuck SSO session and prevent infinite login loops,
      // redirecting them back to the root or login page cleanly.
      this.auth0.logout({ logoutParams: { returnTo: window.location.origin } });
    });

    // Wait for Auth0 SDK to finish processing the callback URL
    this.auth0.isLoading$.pipe(
      filter(loading => !loading),
      take(1),
      switchMap(() => this.auth0.isAuthenticated$)
    ).subscribe({
      next: (isAuthenticated) => {
        console.log('[Auth Callback] isAuthenticated:', isAuthenticated);
        if (isAuthenticated) {
          // If authenticated, we check appState manually but fall back to '/'
          // We don't subscribe to appState$ directly to avoid hanging if it never emits
          this.auth0.appState$.pipe(
            take(1),
            timeout(500),
            catchError(() => of(null))
          ).subscribe({
            next: (state) => this.router.navigateByUrl(state?.target ?? '/'),
            error: () => this.router.navigateByUrl('/')
          });
        } else {
          console.warn('[Auth Callback] User is not authenticated after callback. Redirecting to root.');
          this.router.navigateByUrl('/');
        }
      },
      error: (err) => {
        console.error('Error checking authentication:', err);
        this.router.navigateByUrl('/');
      }
    });
  }
}


